import { getLocalDate } from './getLocalDate'

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const getRecapQuarter = ({
  startsAt,
  endsAt,
}: {
  startsAt: string
  endsAt: string
}): {
  recapTimeframe: string
  releaseDate: string
  recapQuarter: string[]
} => {
  const startsAtDate = getLocalDate(startsAt)
  const endsAtDate = getLocalDate(endsAt)

  const year = endsAtDate.getFullYear()
  const startsAtMonth = MONTHS[startsAtDate.getMonth()]
  const endsAtMonth = MONTHS[endsAtDate.getMonth()]

  const nextMonth = MONTHS[(endsAtDate.getMonth() + 1) % 12]

  const recapQuarter = MONTHS.slice(
    startsAtDate.getMonth(),
    endsAtDate.getMonth() + 1,
  )

  return {
    recapTimeframe: `${startsAtMonth}-${endsAtMonth} ${year}`,
    releaseDate: `${nextMonth} 1`,
    recapQuarter,
  }
}
